<template>
  <q-card
    bordered
    flat
    data-test-id="employee-details-card"
  >
    <q-card-section
      class="q-px-none"
      horizontal
    >
      <q-card-section class="col q-pb-none">
        <div
          class="text-h6"
          style="font-weight: normal;"
        >
          Employee Details
        </div>
      </q-card-section>
    </q-card-section>
    <q-card-section>
      <div class="row">
        <div class="col col-md-4">
          <model-form-input
            field="employeeId"
            class="col-6"
            label="Employee ID"
            :readonly="!$isPermitted($permissions.Team.Manage)"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>
<script>

export default {
  name: 'EmployeeDetailsCard',
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>
